import { render } from "./WCMobileSubpageHeader.vue?vue&type=template&id=45283074&scoped=true"
import script from "./WCMobileSubpageHeader.vue?vue&type=script&lang=js"
export * from "./WCMobileSubpageHeader.vue?vue&type=script&lang=js"

import "./WCMobileSubpageHeader.vue?vue&type=style&index=0&id=45283074&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45283074"]])

export default __exports__